import HealthIndicatorFrecuency from './HealthIndicatorFrecuency.jsx';

export default HealthIndicatorFrecuency;